// สัญญาณเล็กๆ ข้ามการ mount/unmount ของ ProjectSingleDashboard (component นี้ถูก key={id} unmount+remount
// ทุกครั้งที่เปลี่ยนโปรเจกต์ ทำให้ state/ref ภายในทั้งหมดหายไป) — ใช้บอกเรคคอร์ดใหม่ที่เพิ่ง mount ว่า
// ต้องเปิดช่องกรอกแรก (tabOrder=1) ให้เองทันที เพราะมาจากการกด Enter ไล่จบทุกช่องกรอกแล้วกด Enter
// ต่อที่ปุ่ม "โปรเจกต์ถัดไป" (ไม่ใช่จากการคลิกปุ่มนั้นด้วยเมาส์ธรรมดา)
let pending = false;

export function requestAutoFocusFirstField() {
  pending = true;
}

export function consumeAutoFocusFirstField() {
  if (pending) {
    pending = false;
    return true;
  }
  return false;
}
